<template>
    <div class="page-error">
        <header-section />
        <div class="container">
            <div class="row page-error--content">
                <div class="col page-error--img  d-flex justify-content-center">
                    <img
                        class="img-fluid fast animated slideInLeft"
                        alt="Ginny Billetera"
                        src="../assets/images/ginny-miedo.svg">
                </div>
                <div class="col page-error--text fast animated slideInUp">
                    <h1>Error 505</h1>
                    <p>¡Ups! Esta versión no es soportada, por favor vuelve al inicio de la página.</p>
                    <a href="/" class="">Volver al inicio</a>
                </div>
		</div>
    </div>
    </div>
</template>
<script>

export default {
    name: 'Page505',
        components: {
    }
}
</script>
<style lang="scss" scoped>
[data-scroll-class] {
    opacity: 1;
}
// Page Error
.page-error {
    background: url('../assets/images/bg-1.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center 120px;
    background-attachment: fixed;
}
.page-error--content {
    min-height: 725px;
    display: flex;
    align-items: center;
    height: 100%;

    h1 {
        font-family: $primary-font;
        color: $orange-dark-color;
        font-size: $extra-large-font-size;
    }

    p {
        font-size: $medium-font-size;
    }
}
// Medium devices (desktop, 991px)
@media screen and (max-width: 991px) {
    .page-error--content {
        flex-direction: column;
        text-align: center;

        h1 {
            font-size: $large-font-size;
            max-width: 400px;
            width: 100%;
            margin: 0 auto;
        }

        p {
            font-size: $small-font-size;
            margin-top: 15px;
        }

        .page-error--img {
            padding-top: 80px;
            padding-bottom: 40px;
        }
    }
}
// Medium devices (tablet, 768px)
@media screen and (max-width: 768px) {
    .page-error--content {
        .page-error--img {
            position:relative!important;

            .ginny-404 {
                position:absolute;
                bottom: 0;
                position: absolute;
                left: -40%;
                right: 45%;
                top: 0;
            }
            img {
                height: 300px;
            }
        }
    }
}
</style>